// extracted by mini-css-extract-plugin
export default {"color-button":"ColorPicker_color-button_VKu5d","activator":"ColorPicker_activator_BilVc","activatorInner":"ColorPicker_activatorInner_vcSvS"};